import { motion } from "framer-motion";
import { Award, Users, Star } from "lucide-react";
import { useState } from "react";
import { RegistrationModal } from "./RegistrationModal";
import { HeroTitle } from "./hero/HeroTitle";
import { HeroButtons } from "./hero/HeroButtons";

export const Hero = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section
      className="relative min-h-screen bg-gradient-to-b from-purple-50 via-white to-purple-50 py-12 sm:py-20 overflow-hidden"
      aria-label="Hero Section"
    >
      <div className="absolute inset-0 pointer-events-none">
        <motion.div
          animate={{ scale: [1, 1.2, 1], rotate: [0, 10, 0] }}
          transition={{
            duration: 5,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          className="absolute top-20 left-10 w-24 sm:w-32 h-24 sm:h-32 bg-purple-200/50 rounded-blob"
          aria-hidden="true"
        />
        <motion.div
          animate={{ y: [-20, 20, -20], rotate: [0, -10, 0] }}
          transition={{
            duration: 4,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          className="absolute top-40 right-20 w-20 sm:w-24 h-20 sm:h-24 bg-cyan-200/50 rounded-full"
          aria-hidden="true"
        />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col items-center justify-center gap-4">
          <HeroTitle />
          <img
              src="/h.webp"
              alt="A tumble gym promoting physical and athletic development."
              loading="lazy"
              className="rounded-lg shadow-md"
            />
          <HeroButtons onRegisterClick={() => setIsModalOpen(true)} />
         
           
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.2 }}
            className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12 w-full max-w-4xl mx-auto"
          >
            <div
              className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-lg text-center"
              role="region"
              aria-labelledby="certified-coaches"
            >
              <Award className="w-10 h-10 text-primary mx-auto mb-3" />
              <h2
                id="certified-coaches"
                className="text-xl font-bold text-gray-800"
              >
                Certified Coaches
              </h2>
              <p className="text-gray-600 mt-2">
                Coached by national gymnasts and athletes for expert
                development.
              </p>
            </div>

            <div
              className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-lg text-center"
              role="region"
              aria-labelledby="trusted-parents"
            >
              <Users className="w-10 h-10 text-secondary mx-auto mb-3" />
              <h2
                id="trusted-parents"
                className="text-xl font-bold text-gray-800"
              >
                1000+ Students
              </h2>
              <p className="text-gray-600 mt-2">
                Trusted by 1000+ Parents Across India for Expert Child
                Development.
              </p>
            </div>

            <div
              className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-lg text-center"
              role="region"
              aria-labelledby="top-rated"
            >
              <Star className="w-10 h-10 text-accent mx-auto mb-3" />
              <h2 id="top-rated" className="text-xl font-bold text-gray-800">
                5-Star Rated
              </h2>
              <p className="text-gray-600 mt-2">
                Consistently Ranked as the Top Rated Gymnastics Facility in
                India.
              </p>
            </div>
          </motion.div>
        </div>
      </div>

      <RegistrationModal open={isModalOpen} onOpenChange={setIsModalOpen} />
    </section>
  );
};
